import "./footer.css";
export function Footer() {
    return <div className="footer">
        <a href="https://patrick246.de/impressum.html">Imprint</a>
        <a href="https://github.com/patrick246/blahaj.lgbt">GitHub</a>
        <a href="https://patrick246.de">by patrick246</a>
    </div>
}